import type { TFunction } from 'i18next'

// 本站固定 siteId — 每个站点独立部署，各自控制台只管自己的站，与其他站无关联
export const CRAWLER_SITE_ID = 'aiproxys'

export function getNewsCrawlerSectionNavItems(_t: TFunction) {
  return [{ title: '新闻爬取', url: '/system-settings/content/news-crawler' }]
}
